module.exports = __webpack_public_path__ + "img/lyhour_mobile.3366cf18.png";